import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { map, take } from 'rxjs';


export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  return authService.authStatus$.pipe(
    take(1),
    map(status => {
      if (status.loggedIn) {
        router.navigate(['/onboarding/register/form']);
        return false;
      }
      return true;
    })
  );
};
